<app-ngx-mat-table
  tableName="Campaigns Table"
  description="Shows a table of all campaigns and enables their manipulation."
  dataType="campaign"
  sortActive="status"
  [tableData]="tableData"
  [showActions]="showActions"
  (clickedButton)="clickedButton($event)"
  i18n-tableName
  i18n-description
></app-ngx-mat-table>
<router-outlet></router-outlet>
